var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShoppingCartColor = function SvgShoppingCartColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E0478"
    },
    d: "M506.34,109.739c4.802,5.883,6.663,13.526,5.141,20.956l-35.173,170.674 c-2.388,11.641-12.747,20.076-24.614,20.076H140.794l7.404,35.915h301.159c6.952,0,12.571,5.632,12.571,12.571 c0,6.939-5.619,12.571-12.571,12.571H148.198c-11.879,0-22.225-8.435-24.626-20.063L62.742,67.174L7.568,43.214 c-6.373-2.753-9.29-10.157-6.524-16.531s10.17-9.29,16.531-6.524l55.186,23.947c7.492,3.256,12.96,9.981,14.607,17.989l7.907,38.391 h391.581C494.436,100.487,501.551,103.856,506.34,109.739z M451.695,296.302l35.161-170.674H100.454l35.161,170.674H451.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94E7EF"
    },
    d: "M486.855,125.629l-35.161,170.674h-316.08l-35.161-170.674H486.855z M396.283,178.325 c0-6.939-5.619-12.571-12.571-12.571h-180.14c-6.952,0-12.571,5.632-12.571,12.571s5.619,12.571,12.571,12.571h180.14 C390.664,190.896,396.283,185.264,396.283,178.325z M386.478,243.606c0-6.939-5.619-12.571-12.571-12.571H213.378 c-6.952,0-12.571,5.632-12.571,12.571s5.619,12.571,12.571,12.571h160.529C380.858,256.176,386.478,250.545,386.478,243.606z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E0478"
    },
    d: "M372.625,402.827c24.84,0,45.029,20.201,45.029,45.029c0,24.827-20.189,45.029-45.029,45.029 c-24.827,0-45.029-20.201-45.029-45.029C327.596,423.029,347.797,402.827,372.625,402.827z M392.512,447.856 c0-10.962-8.913-19.887-19.887-19.887c-10.962,0-19.887,8.925-19.887,19.887c0,10.962,8.925,19.887,19.887,19.887 C383.599,467.743,392.512,458.818,392.512,447.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E0478"
    },
    d: "M383.712,165.755c6.952,0,12.571,5.632,12.571,12.571s-5.619,12.571-12.571,12.571h-180.14 c-6.952,0-12.571-5.632-12.571-12.571s5.619-12.571,12.571-12.571H383.712z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B8CCC"
    },
    d: "M372.625,427.969c10.974,0,19.887,8.925,19.887,19.887c0,10.962-8.913,19.887-19.887,19.887 c-10.962,0-19.887-8.925-19.887-19.887C352.738,436.894,361.663,427.969,372.625,427.969z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E0478"
    },
    d: "M373.907,231.035c6.952,0,12.571,5.632,12.571,12.571s-5.619,12.571-12.571,12.571H213.378 c-6.952,0-12.571-5.632-12.571-12.571s5.619-12.571,12.571-12.571H373.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E0478"
    },
    d: "M214.685,402.827c24.827,0,45.029,20.201,45.029,45.029c0,24.827-20.201,45.029-45.029,45.029 s-45.029-20.201-45.029-45.029C169.656,423.029,189.858,402.827,214.685,402.827z M234.572,447.856 c0-10.962-8.925-19.887-19.887-19.887c-10.962,0-19.887,8.925-19.887,19.887c0,10.962,8.925,19.887,19.887,19.887 C225.647,467.743,234.572,458.818,234.572,447.856z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B8CCC"
    },
    d: "M214.685,427.969c10.962,0,19.887,8.925,19.887,19.887c0,10.962-8.925,19.887-19.887,19.887 c-10.962,0-19.887-8.925-19.887-19.887C194.798,436.894,203.723,427.969,214.685,427.969z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCartColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart-color.7aaa1341.svg";
export { ForwardRef as ReactComponent };